import { render, staticRenderFns } from "./feedSearch.vue?vue&type=template&id=d80d82b6&scoped=true"
import script from "./feedSearch.vue?vue&type=script&lang=js"
export * from "./feedSearch.vue?vue&type=script&lang=js"
import style0 from "./feedSearch.vue?vue&type=style&index=0&id=d80d82b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80d82b6",
  null
  
)

export default component.exports